import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const ActivationSuccess = () => {
    const navigate = useNavigate();

    const handleNextGiftcard = () => {
        navigate('/customer-form');
    };

    return (
        <Box sx={{ 
            minHeight: '100vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            bgcolor: 'grey.50',
            p: 2
        }}>
            <Paper elevation={3} sx={{ 
                p: 6, 
                maxWidth: 600, 
                width: '100%',
                borderRadius: 2,
                textAlign: 'center'
            }}>
                <CheckCircleIcon 
                    sx={{ 
                        fontSize: 80, 
                        color: 'success.main', 
                        mb: 3 
                    }} 
                />
                
                <Typography variant="h4" component="h1" gutterBottom color="success.main">
                    Giftcard Activated Successfully!
                </Typography>
                
                <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
                    Your giftcard has been activated and is ready to use.
                </Typography>

                <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
                    Please return to server for next step or press button below to activate another giftcard.
                </Typography>

                <Button 
                    variant="contained" 
                    size="large"
                    onClick={handleNextGiftcard}
                    sx={{ 
                        mt: 2,
                        px: 4,
                        py: 1.5
                    }}
                >
                    Next Giftcard
                </Button>
            </Paper>
        </Box>
    );
};

export default ActivationSuccess;
